import React from 'react';
import { motion } from 'framer-motion';
import { LayersIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { brand, heroCta, heroGuarantee, heroImage, heroNote } from '../data/content';
const ease = [0.23, 1, 0.32, 1] as const;
interface HeroProps {
  subheadline?: string;
  description?: string;
}
export function Hero({
  subheadline = brand.subheadline,
  description = brand.description
}: HeroProps) {
  return <section className="w-full bg-white pb-14 pt-10 md:pb-20 md:pt-14" data-id="element-135" data-mp="127ect9b6vhbc">
      <div className="mx-auto w-full max-w-5xl px-5 text-center md:px-8" data-id="element-136" data-mp="xaxg3qpxbumn">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        ease
      }} className="text-xs font-extrabold uppercase tracking-wider text-blue-600 sm:text-sm md:tracking-widest" data-id="element-137" data-mp="sai3x2hdot69">
          {brand.eyebrow}
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.05,
        ease
      }} className="mx-auto mt-4 max-w-4xl text-3xl font-extrabold leading-tight tracking-tight text-slate-900 sm:text-5xl md:text-6xl md:leading-none" data-id="element-138" data-mp="381nwtf3hn36l">
          {brand.headline} <span className="text-blue-600" data-id="element-139" data-mp="3e9frrdwdw8m7">{brand.headlineAccent}</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.45,
        delay: 0.1,
        ease
      }} className="mx-auto mt-6 max-w-2xl" data-id="element-140" data-mp="3eb8zkwiqgyvs">
          <p className="inline-flex items-center gap-2 text-lg font-extrabold tracking-tight text-slate-900 md:text-2xl" data-id="element-141" data-mp="2qk3kijkmaamj">
            <LayersIcon className="h-5 w-5 shrink-0 text-blue-600" aria-hidden="true" data-id="element-142" data-mp="2vi55xb5imm16" />
            {brand.name}
          </p>
          <p className="mt-1 text-base font-bold uppercase tracking-wide text-blue-600 md:text-lg" data-id="element-143" data-mp="2hjoz7k7nkvj1">
            {subheadline}
          </p>
          <p className="mx-auto mt-4 text-base leading-relaxed text-blue-900/75 md:text-lg" data-id="element-144" data-mp="s21j2e1koi11">
            {description}
          </p>
        </motion.div>

        <motion.img initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.14,
        ease
      }} src={heroImage} alt="Atlas Kinesio-Visual: 100 mapas visuales + 6 kits profesionales para entrenadores personales" className="mx-auto mt-8 w-full max-w-2xl" width={1240} height={1240} data-id="element-145" data-mp="najivs7dilh4" />

        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.45,
        delay: 0.2,
        ease
      }} className="mx-auto mt-8 max-w-2xl" data-id="element-146" data-mp="162m47guympxp">
          <p className="text-xl font-extrabold italic tracking-tight text-blue-600 md:text-2xl" data-id="element-147" data-mp="x3h6gcr830ml">
            {brand.tagline}
          </p>
          <CtaButton size="xl" className="mt-6 w-full" data-id="element-148" data-mp="3hr3q7rbx233p">
            {heroCta}
          </CtaButton>
          <p className="mx-auto mt-3 text-sm font-semibold text-blue-900/70" data-id="element-149" data-mp="1xa44lgt9woko">{heroNote}</p>
          <p className="mt-2 inline-flex items-center gap-2 text-sm font-medium text-blue-900/70" data-id="element-150" data-mp="21a4rzqycoa3v">
            <ShieldCheckIcon className="h-4 w-4 shrink-0 text-emerald-500" aria-hidden="true" data-id="element-151" data-mp="269r41x2fzkb3" />
            {heroGuarantee}
          </p>
        </motion.div>
      </div>
    </section>;
}